<template>
  <div class="LED_resource">
    <div style="padding: 0px 20px">
      <div class="search">
        <div class="search_box">
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[0].title}}</span>
            <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
              <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[1].title}}</span>
            <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
              <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[2].title}}</span>
            <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
              <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getledlist()">
              <span class="el-icon-search"></span>搜索
            </button>
          </div>
          <div class="add_btn_box">
<!--            <button :class='["add_btn","add","icon_btn","clearborder"]'>-->
<!--              <span class="icon-9"></span>播放日志-->
<!--            </button>-->
          </div>
        </div>
      </div>

      <!--        表格-->
      <div class="table_content">
        <table>
          <thead>
            <tr>
              <th style="width: 50px">
                <input type="checkbox" name="all" />
              </th>
              <th style="padding-left: 30px">序号</th>
              <th>设备序列号</th>
              <th>灯杆编号</th>
              <th>GIS定位</th>
              <th>设备状态</th>
              <th>屏幕状态</th>
              <th>分辨率</th>
              <th>亮度</th>
              <th>色温</th>
              <th>当前播出节目</th>
              <th>关联节目</th>
              <th>安装时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in data" :key='index'  :class="index===0?['now']:[]">
              <td>
                <input type="checkbox" name />
              </td>
              <td style="padding-left: 30px">{{index+1}}</td>
              <td>{{item.device_num}}</td>
              <td>{{item.lamppost_id}}</td>
              <td>{{item.site}}</td>
              <td v-if="item.signal_status=='1'">在线</td>
              <td v-else>离线</td>
              <td v-if="item.screen_status=='1'">开</td>
              <td v-else>关</td>
              <td>{{item.resolution}}</td>
              <td>{{item.brightness}}</td>
              <td>{{item.colortemp}}</td>
              <td>{{item.program_name}}</td>
              <td>
                <span style="color: #02efff;cursor: pointer" @click="selectRow(index,item.id)">查看</span>
              </td>
              <td>{{item.create_datetime}}</td>
              <td class="table_btn_box">
                <button
                  class="table_btn"
                  @click="close(item.id)"
                  v-if="item.screen_status=='1'"
                  style=" margin-right: 20px;"
                >关屏</button>
                <button
                  class="table_btn"
                  @click="open(item.id)"
                  v-else
                  style=" margin-right: 20px;"
                >开屏</button>
                <button class="table_btn" @click="Led_fix(item.id)" style=" margin-right: 20px;">编辑</button>
                <button class="table_btn" @click="restart(item.id)">重启</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>
          当前记录
          <span>1</span>到
          <span>5</span>条，共
          <span>5</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"
          ></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"
          ></button>
          第
          <span>1</span>/
          <span>1</span>页
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"
          ></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"
          ></button>
        </p>
      </div>

      <div :class='["information_box","light_border","weather_box"]' :style="[{width:'100%'},{height:'280px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="details">
            <h1>
              <button :class='["search_btn","green","icon_btn","clearborder"]' @click="add_command=!add_command">添加</button>
              <button :class='["search_btn","blue","icon_btn","clearborder"]'>排序</button>
              <button :class='["search_btn","yellow","icon_btn","clearborder"]' @click="deleteLedUse()">删除</button>
              <div>
                <input type="checkbox" id="togroups"/>同时应用到组群
                <input type="checkbox" id="toteam"/>同时应用到小组
                <button
                  :class='["search_btn","add","icon_btn","clearborder"]'
                  :style="{width:'80px'}" @click="LedUse()"
                >应用</button>
              </div>
            </h1>
            <div class="monitoringPoint">
              <table>
                <thead>
                  <tr>
                    <th style="width: 50px !important;">
                      <input type="checkbox" name="issue_all" />
                    </th>
                    <th style="width: 100px !important;">序号</th>
                    <th>指令</th>
                    <th>内容</th>
                    <th>执行时间</th>
                    <th>结束时间</th>
                    <th>开始日期</th>
                    <th>结束日期</th>
                    <th>有效周期</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in command_data" :key="index">
                    <td style="width: 50px !important;">
                      <input type="checkbox" name="issue" />
                    </td>
                    <td style="width: 100px !important;">{{index+1}}</td>
                    <td v-if="item.name.toLowerCase()==='sleep'">关屏</td>
                    <td v-else-if="item.name.toLowerCase()==='wakeup'">开屏</td>
                    <td v-else>播放节目</td>
                    <td v-if="item.name!=='play_program'"></td>
                    <td v-else>{{item.program_name}}</td>
                    <td v-if="item.name!=='play_program'">{{item.op_time}}</td>
                    <td v-else>{{item.start_time}}</td>
                    <td v-if="item.name!=='play_program'"></td>
                    <td v-else>{{item.end_time}}</td>
                    <td>{{item.start_datetime.substring(0,10)}}</td>
                    <td>{{item.end_datetime.substring(0,10)}}</td>
                    <td>{{item.limit_weekday}}</td>
                    <td class="table_btn_box">
                      <button class="table_btn" @click="update_command=!update_command,getNumber(item.id,item.name,item.program,item.start_time,item.end_time,item.start_datetime,item.end_datetime,item.limit_weekday)">编辑</button>
                      <button class="table_btn" style="margin-left: 20px" @click="deleteLedUse(item.id)">删除</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="mark" v-if="fix_show">
        <div class="mark_close" @click="fix_show=!fix_show"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'500px'},{'margin-top':'0px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>编辑</h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <div class="model_input_box">
                <div>
                  <span>亮度：</span>
                </div>
                <div>
                  <input
                    v-model="fix_brightness"
                    onkeyup="if(/\D/.test(this.value)){this.value=''}"
                    type="text"
                    placeholder="温度范围0-100"
                  />
                </div>
              </div>
              <div class="model_input_box">
                <div>
                  <span>色温：</span>
                </div>
                <div>
                  <input
                    v-model="fix_colortemp"
                    onkeyup="if(/\D/.test(this.value)){this.value=''}"
                    type="text"
                    placeholder="色温范围2000-10000"
                  />
                </div>
              </div>
            </div>
            <div class="sbt_box">
              <button
                :class='["add_btn","delete","icon_btn","clearborder"]'
                @click="fix_cancel()"
              >取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="fix_sbt()">保存</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 添加LED指令 -->
    <transition name="fade">
      <div class="mark" v-if="add_command">
        <div class="mark_close" @click="add_command=!add_command"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'800px'},{'margin-top':'0px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>添加定时任务</h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <div class=" twoinput">
                <div style="display:flex;">
                  <div  class="input_span"><span>指令：</span></div>
                  <div>
                    <!-- <input v-model="fix_brightness" onkeyup="if(/\D/.test(this.value)){this.value=''}" type="select" placeholder="温度范围0-100"/> -->
                    <select v-model="directive">
                      <!-- <option v-for="item in groupsList" v-bind:value="item.id" v-bind:key="item.id" >{{ item.name }}</option> -->
                      <option value="sleep">睡眠</option>
                      <option value="wakeup">唤醒</option>
                      <option value="play_program">播放节目</option>
                    </select>
                  </div>
                </div>
                <div style="display:flex;" v-show="directive == 'play_program'">
                   <div  class="input_span" style="width:100px;"><span style="width:100px;">内容：</span></div>
                   <div>
                      <select v-model="program_id" @change="selectProgram">
                        <!-- <option v-for="item in groupsList" v-bind:value="item.id" v-bind:key="item.id" >{{ item.name }}</option> -->
                        <option  v-for="(item,index) in content_data" :key="index" v-bind:value="item.id" >{{item.name}}</option>
                      </select>
                    </div>
                </div>  
              </div>
              <div class=" twoinput">
                <div style="display:flex;">
                  <div class="input_span"><span>执行时间：</span></div>
                  <div>
                    <el-time-picker
                      v-model="execute_time"
                      type="time" value-format="HH:mm:ss"
                      placeholder="选择时间" style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                    </el-time-picker>
                  </div>
                </div>
                <div style="display:flex;" v-show="directive == 'play_program'">
                  <div class="input_span" style="width:100px;"><span style="width:100px;">结束时间：</span></div>
                  <div>
                      <el-time-picker  v-model="end_time" type="time" value-format="HH:mm:ss"
                      placeholder="选择时间"  style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                    </el-time-picker>
                  </div>
                </div>
                
              </div>
              <div class=" twoinput " >
                <div style="display:flex;">
                  <div class="input_span"><span>有效日期：</span></div>
                  <div><el-date-picker
                      v-model="start_date"
                      type="date"  value-format="yyyy-MM-dd"
                      placeholder="选择日期"  style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                    </el-date-picker></div>
                </div>
                <div style="display:flex;">
                  <div class="input_span" style="width:100px;"><span style="text-align:center;width:120px;" >至</span></div>
                  <div><el-date-picker
                      v-model="end_date"
                      type="date" value-format="yyyy-MM-dd"
                      placeholder="选择日期" style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                    </el-date-picker></div>
                </div>
              </div>
                <div style="height：80px; line-height:80px; display:flex;    margin: 10px 20px;">
                <div style="width:140px; text-align:right;"><span style="color:#ffffff; width:140px; text-align:right;">有效周期：</span></div>
                <div class="cycle" style="width：500px;">
                  <div><input id="LampWeekAll" type="checkbox" value="1,2,3,4,5,6,7" v-model="limit_weekday">全部</div>
                  <div><input type="checkbox" name="limit_weekday" value="1" v-model="limit_weekday">星期一</div>
                  <div><input type="checkbox" name="limit_weekday" value="2" v-model="limit_weekday">星期二</div>
                  <div><input type="checkbox" name="limit_weekday" value="3" v-model="limit_weekday">星期三</div>
                  <div><input type="checkbox" name="limit_weekday" value="4" v-model="limit_weekday">星期四</div>
                  <div><input type="checkbox" name="limit_weekday" value="5" v-model="limit_weekday">星期五</div>
                  <div><input type="checkbox" name="limit_weekday" value="6" v-model="limit_weekday">星期六</div>
                  <div><input type="checkbox" name="limit_weekday" value="7" v-model="limit_weekday">星期日</div>
                </div>
              </div>
            </div>
            <div class="sbt_box">
              <button
                :class='["add_btn","delete","icon_btn","clearborder"]'
                @click="add_command=!add_command"
              >取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="confirmAddCommnad()">保存</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 修改LED指令 -->
    <transition name="fade">
      <div class="mark" v-if="update_command">
        <div class="mark_close" @click="update_command=!update_command"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'800px'},{'margin-top':'0px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>修改定时任务</h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <div class=" twoinput">
                <div style="display:flex;">
                  <div  class="input_span"><span>指令：</span></div>
                  <div>
                    <!-- <input v-model="fix_brightness" onkeyup="if(/\D/.test(this.value)){this.value=''}" type="select" placeholder="温度范围0-100"/> -->
                    <select v-model="directive">
                      <!-- <option v-for="item in groupsList" v-bind:value="item.id" v-bind:key="item.id" >{{ item.name }}</option> -->
                      <option value="sleep">睡眠</option>
                      <option value="wakeup">唤醒</option>
                      <option value="play_program">播放节目</option>
                    </select>
                  </div>
                </div>
                <div style="display:flex;" v-show="directive == 'play_program'">
                  <div  class="input_span" style="width:100px;"><span style="width:100px;">内容：</span></div>
                  <div>
                    <select v-model="program_id" @change="selectProgram">
                      <!-- <option v-for="item in groupsList" v-bind:value="item.id" v-bind:key="item.id" >{{ item.name }}</option> -->
                      <option  v-for="(item,index) in content_data" :key="index" v-bind:value="item.id" >{{item.name}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class=" twoinput">
                <div style="display:flex;">
                  <div class="input_span"><span>执行时间：</span></div>
                  <div>
                    <el-time-picker
                      v-model="execute_time"
                      type="time" value-format="HH:mm:ss"
                      placeholder="选择时间" style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                    </el-time-picker>
                  </div>
                </div>
                <div style="display:flex;" v-show="directive == 'play_program'">
                  <div class="input_span" style="width:100px;"><span style="width:100px;">结束时间：</span></div>
                  <div>
                    <el-time-picker  v-model="end_time" type="time" value-format="HH:mm:ss"
                                     placeholder="选择时间"  style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                    </el-time-picker>
                  </div>
                </div>

              </div>
              <div class=" twoinput " >
                <div style="display:flex;">
                  <div class="input_span"><span>有效日期：</span></div>
                  <div><el-date-picker
                    v-model="start_date"
                    type="date"  value-format="yyyy-MM-dd"
                    placeholder="选择日期"  style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                  </el-date-picker></div>
                </div>
                <div style="display:flex;">
                  <div class="input_span" style="width:100px;"><span style="text-align:center;width:120px;" >至</span></div>
                  <div><el-date-picker
                    v-model="end_date"
                    type="date" value-format="yyyy-MM-dd"
                    placeholder="选择日期" style=" width: 180px;height: 32px;line-height:32px;margin-left: 20px; ">
                  </el-date-picker></div>
                </div>
              </div>
              <div style="height：80px; line-height:80px; display:flex;    margin: 10px 20px;">
                <div style="width:140px; text-align:right;"><span style="color:#ffffff; width:140px; text-align:right;">有效周期：</span></div>
                <div class="cycle" style="width：500px;">
                  <div><input id="LampWeekAll" type="checkbox" value="1,2,3,4,5,6,7" v-model="limit_weekday">全部</div>
                  <div><input type="checkbox" name="limit_weekday" value="1" v-model="limit_weekday">星期一</div>
                  <div><input type="checkbox" name="limit_weekday" value="2" v-model="limit_weekday">星期二</div>
                  <div><input type="checkbox" name="limit_weekday" value="3" v-model="limit_weekday">星期三</div>
                  <div><input type="checkbox" name="limit_weekday" value="4" v-model="limit_weekday">星期四</div>
                  <div><input type="checkbox" name="limit_weekday" value="5" v-model="limit_weekday">星期五</div>
                  <div><input type="checkbox" name="limit_weekday" value="6" v-model="limit_weekday">星期六</div>
                  <div><input type="checkbox" name="limit_weekday" value="7" v-model="limit_weekday">星期日</div>
                </div>
              </div>
            </div>
            <div class="sbt_box">
              <button
                :class='["add_btn","delete","icon_btn","clearborder"]'
                @click="update_command=!update_command,deleteNumber()"
              >取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="confirmUpdateCommnad()">保存</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" v-on:leave="leave">
      <div class="mark" v-if="msg_show">
        <div class="mark_close" @click="msg_show=!msg_show"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'500px'},{'margin-top':'0px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="information_content issue_search_box model">
            <div id="msg">{{message}}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "equipment_management",
  data() {
    return {
      fix_show: false,
      msg_show: false,
      websock: null,
      search: [
        {
          title: '选择项目',
          options: [],
        }, {
          title: '选择群组',
          options: [],
        }, {
          title: '选择小组',
          options: [],
        },
      ],
      projectList:[],
      teamList:[],
      workList:[],
      selectProjectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
      selectTeamValue:'',
      selectWorkValue:'',
      to_group:false,
      to_team:false,
      issue_search: [
        {
          title: "选择群组",
          select: [{ option: "全部群组" }, { option: "项目1" }]
        },
        {
          title: "选择小组",
          select: [{ option: "全部小组" }, { option: "项目1" }]
        }
      ],

      //初始化
      scheduleid:[],
      LedId:"",
      page_start: "0",
      page_size: "5",
      project_id: "",
      groups: "",
      group: "",
      data: "",
      command_data: [],
      now: 0,
      message: "操作成功",
      Led_fix_id: "",
      fix_brightness: "",
      fix_colortemp: "",
      websock: null,
      add_command: false,
      update_command:false,
      directive:null,
      program_id:null,
      program_name:null,
      execute_time:null,
      end_time:null,
      start_date:null,
      end_date:null,
      content_data:[],
      limit_weekday:[]
    };
  },
  methods: {
    InitLeftMenu: function() {
      this.$emit("getMessage", "4", "3");
    },
    add: function() {
      this.$router.push({ path: "/monitoring/MsgEvent_managing_add" });
    },


    getNumber:function(id,name,program_name,start_time,end_time,start_datetime,end_datetime,limit_weekday){
      this.directive = name;
      this.program_id = program_name;
      this.execute_time = start_time;
      this.end_time = end_time;
      this.start_date = start_datetime;
      this.end_date = end_datetime;
      this.limit_weekday = limit_weekday;
      this.schedule_id = id;
      // alert(this.directive)
      // alert(this.program_id)
      // alert(this.execute_time)
      // alert(this.end_time)
      // alert(this.start_date)
      // alert(this.end_date)
      // alert(this.limit_weekday)
      // alert(this.schedule_id)
    },

    deleteNumber:function(){
      this.directive = '';
      this.program_id = '';
      this.execute_time = '';
      this.end_time = '';
      this.start_date = '';
      this.end_date = '';
      this.limit_weekday = '';
      this.schedule_id = '';
    },


    confirmUpdateCommnad:function(){
      fetch("/api/v1/led/schedule/update",{
        method:'post',
        body:JSON.stringify({
          "schedule_id" : this.schedule_id,
          "schedule" :{
            directive: this.directive,
            program_id: this.program_id,
            execute_time: this.execute_time,
            end_time: this.end_time,
            start_date:this.start_date,
            end_date: this.end_date,
            limit_weekday: this.limit_weekday,
          },
        })
      }).then(result => {
        return result.json(); //解析流
      }).then(data => {
        if (data.code == '200'){
          var item = {
            "name": this.directive,
            "program_id": this.program_id,
            "program_name": this.program_name,
            "execute_time": this.execute_time,
            "end_time": this.end_time,
            "start_datetime":this.start_date,
            "end_datetime": this.end_date,
            "limit_weekday":this.limit_weekday,
          }
          if(item.name.toLowerCase() != "play_program"){
            item['op_time'] = this.execute_time
          }else{
            item['start_time'] = this.execute_time
          }
          this.command_data.push(item)
        }
        alert('修改成功！')
        console.log(this.command_data);
      }).catch(error => {
        console.log(error);
      });
      this.update_command=!this.update_command;
    },





    //获取小组列表
    getSelectWork:function(id){
      fetch("/api/v1/controller/list", {
        method: 'post',
        body: JSON.stringify({
          "groups_id":id,
          "page_size":10,
          "page_start":0,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "小组数据获取成功";
            this.search[2].options=[];
            this.workList = data.data;
            let options = this.search[2].options;
            for (let i=0;i<this.workList.length;i++){
              let projectObj = {};
              projectObj.label = this.workList[i].name;
              projectObj.value = this.workList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },



    //获取群组列表
    getSelectTeam:function(id){
      fetch("/api/v1/groups/list", {
        method: 'post',
        body: JSON.stringify({
          "project_id":id,
          "page_size":10,
          "page_start":0,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "群组数据获取成功";
            this.search[1].options=[];
            this.search[2].options=[];
            this.teamList = data.data;
            let options = this.search[1].options;
            for (let i=0;i<this.teamList.length;i++){
              let projectObj = {};
              projectObj.label = this.teamList[i].name;
              projectObj.value = this.teamList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },


    //获取项目列表
    getProjectList:function(){
      fetch("/api/v1/project/list", {
        method: 'post',
        body: JSON.stringify({

        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "项目数据获取成功";
            this.projectList = data.data;
            let options = this.search[0].options;
            for (let i=0;i<this.projectList.length;i++){
              let projectObj = {};
              projectObj.label = this.projectList[i].name;
              projectObj.value = this.projectList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },


    selectRow: function(index,led_id) {
      console.log(led_id);
      this.row = index;
      fetch("/api/v1/led/schedule/list", {
        method: "post",
        body: JSON.stringify({
          "led_id" : led_id,
        })
      }).then(result => {
          return result.json(); //解析流
      }).then(data => {
        if(data.code == '200'){
          this.command_data = data.data;
          this.LedId = led_id+"";
          if(this.command_data.length!=0){
            this.scheduleid.push(this.command_data[0].id);
          }
        }
      }).catch(error => {
          console.log(error);
      });
    },

    //编辑
    Led_fix: function(id) {
      this.Led_fix_id = id;
      this.fix_show = !this.fix_show;
    },
    fix_cancel: function() {
      this.Led_fix_id = "";
      this.fix_brightness = "";
      this.fix_colortemp = "";
      this.fix_show = !this.fix_show;
    },
    fix_sbt: function() {
      if (this.Led_fix_id !== "" && this.fix_brightness !== "") {
        fetch("/zd_cloud/api/v1/led/command/brightness/", {
          method: "post",
          body: JSON.stringify({
            id: this.Led_fix_id,
            brightness: this.fix_brightness
          })
        })
          .then(result => {
            return result.json(); //解析流
          })
          .then(status => {
            this.fix_show = !this.fix_show;
            this.message = status.msg;
            this.msg_show = !this.msg_show;
            this.$options.methods.msg();
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        alert("请输入要修改的色温或亮度");
      }
    },


    //重启
    restart: function(id) {
      fetch("/api/v1/led/command/reboot", {
        method: 'post',
        body: JSON.stringify({
          "led_id" : id+"",
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          if (data.code == "200") {
            this.message = "LED屏重启成功";
            this.refresh = true;
            this.msg_show = !this.msg_show;
            alert(this.message);
          } else {
            this.message = "LED异常，请重试";
            this.msg_show = !this.msg_show;
            alert(this.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },


    //开屏
    open: function(id) {
      fetch("/api/v1/led/command/wakeup", {
        method: 'post',
        body: JSON.stringify({
          "led_id" : id+"",
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          if (data.code == "200") {
            this.message = "LED屏开启成功";
            this.refresh = true;
            this.msg_show = !this.msg_show;
            alert(this.message);
          } else {
            this.message = "LED异常，请重试";
            this.msg_show = !this.msg_show;
            alert(this.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },


    //关屏
    close: function(id) {
      fetch("/api/v1/led/command/sleep", {
        method: 'post',
        body: JSON.stringify({
          "led_id" : id+"",
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          if (data.code == "200") {
            this.message = "LED屏关闭成功";
            this.refresh = true;
            this.msg_show = !this.msg_show;
            alert(this.message);
          } else {
            this.message = "LED异常，请重试";
            this.msg_show = !this.msg_show;
            alert(this.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //添加LED屏排程
    confirmAddCommnad:function(){
      fetch("/api/v1/led/schedule/add", {
        method: "post",
        body: JSON.stringify({
          "led_id" : this.LedId,
          "schedule" :{
            directive: this.directive,
            program_id: this.program_id,
            execute_time: this.execute_time,
            end_time: this.end_time,
            start_date:this.start_date,
            end_date: this.end_date,
            limit_weekday: this.limit_weekday.join(','),
          },
        })
      }).then(result => {
          return result.json(); //解析流
      }).then(data => {
        if (data.code == '200'){
          var item = {
            "name": this.directive,
            "program_id": this.program_id,
            "program_name": this.program_name,
            "execute_time": this.execute_time,
            "end_time": this.end_time,
            "start_datetime":this.start_date,
            "end_datetime": this.end_date,
            "limit_weekday":this.limit_weekday.join(','),
          }
          if(item.name.toLowerCase() != "play_program"){
            item['op_time'] = this.execute_time
          }else{
            item['start_time'] = this.execute_time
          }
          this.command_data.push(item)
        }
        console.log(this.command_data);
      }).catch(error => {
          console.log(error);
      });
      this.add_command=!this.add_command;
    },
    selectProgram(ele){
      this.program_name = $(ele.target).find("option:selected").text();
      this.program_id  = ele.target.value;
    },

    //获取排程列表
    // GetCommnadList:function () {
    //   fetch("/api/v1/led/schedule/list", {
    //     method: 'post',
    //     body: JSON.stringify({
    //       "led_id" : "1"
    //     })
    //   })
    //     .then(result => {
    //       return result.json();//解析流
    //     })
    //     .then(data => {
    //       this.dynamicTags=data.data;
    //       console.log(this.dynamicTags);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    //调度LED屏
    LedUse:function () {
      if($("#togroups").is(":checked")){//选中
        this.to_group=true
      }
      if($("#toteam").is(":checked")){//选中
        this.to_team=true
      }
      fetch("/api/v1/led/schedule/apply", {
        method: 'post',
        body: JSON.stringify({
          "led_id" : this.LedId,
          to_groups:this.to_group,
          to_group:this.to_team,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          if (data.code == "200") {
            this.message = "LED屏调度成功";
            this.refresh = true;
            this.msg_show = !this.msg_show;
            this.to_group=false;
            this.to_team=false;
          }
          else {
            this.message = "LED异常，请重试";
            this.msg_show = !this.msg_show;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },



    //删除LED调度
    deleteLedUse:function (id) {
      fetch("/api/v1/led/schedule/delete", {
        method: 'post',
        body: JSON.stringify({
          "led_id" : [this.LedId],
          "schedule_id" : [id],
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          if (data.code == "200") {
            this.message = "LED屏调度删除成功";
            this.refresh = true;
            this.msg_show = !this.msg_show;
          } else {
            this.message = "LED异常，请重试";
            this.msg_show = !this.msg_show;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getledlist:function () {
      //获取LED屏列表
      fetch("/api/v1/led/list", {
        method: "post",
        body: JSON.stringify({
          project_id: this.selectProjectValue,
          groups_id: this.selectTeamValue,
          controller_id: this.selectWorkValue,
          page_start: "0",
          page_size: "5"
        })
      }).then(result => {
        return result.json(); //解析流
      }).then(data => {
        console.log(data);
        this.data = data.data;
        this.selectProjectValue='';
        this.selectTeamValue='';
        this.selectWorkValue='';
      }).catch(error => {
        console.log(error);
      });
    }


  },

  mounted() {
    this.getledlist();

    //获取节目列表
    fetch("/api/v1/led/program/list", {
      method: "post",
      body: JSON.stringify({
        // project_id: this.project_id,
        // groups: this.groups,
        // group: this.group,
        page_start: "0",
        page_size: "999"
      })
    }).then(result => {
        return result.json(); //解析流
    }).then(data => {
        console.log(data);
        this.content_data = data.data;
    }).catch(error => {
        console.log(error);
    });

    //页面刚进入时开启长连接
    // this.initWebSocket();

  },
  created() {
    //this.GetCommnadList();
    this.InitLeftMenu();
    this.getProjectList();
    this.initWebSocket();

  },
  destroyed: function() {
    //页面销毁时关闭长连接
    this.webSocketClose();
  }
};
</script>

<style scoped>
.cycle{
  display: flex;
  color: #ffffff;
  flex-wrap: wrap;
  width: calc(100% - 160px);
  margin-left: 20px;
}
.cycle > div{
  padding: 0px 10px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cycle input{
  margin-right: 10px;
}
.mark {
  position: absolute;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 999;
  left: 0;
  top: 0;
}

.mark_close {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}

.search {
  width: 100%;
  height: 100px;
  padding: 20px 0px 0px;
}

.search_box {
  width: 100%;
  height: 100%;
  margin-right: 10px;
  background: #16518d;
  border-radius: 6px;
  float: left;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}

.search_options_box {
  width: 16%;
  padding: 0 10px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.search_options_box > span {
  width: 64px;
  margin-right: 8px;
  text-align: right;
  color: #ffffff;
}

.search_options_box > select {
  width: calc(100% - 72px);
  height: 36px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid #ffffff;
  color: #ffffff;
  appearance: none;
  padding-left: 10px;
  font-size: 16px;
  outline: none;
  cursor: pointer;
}

.search_options_box option {
  color: #000000;
}

.search_options_box > img {
  position: absolute;
  top: 48px;
  right: 20px;
  cursor: pointer;
}

.search_btn_box {
  width: 80px;
  padding: 10px;
}

.clearborder {
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search_btn {
  width: 100%;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
}

.add_btn {
  width: 110px;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
  float: right;
  margin-right: 20px;
}

.icon_btn span {
  margin-right: 8px;
}

.green {
  background: #21b868;
  color: #ffffff;
}

.green:active {
  background: #15a95a;
}

.blue {
  background: #7aafeb;
  color: #ffffff;
}

.blue:active {
  background: #4699f7;
}

.yellow {
  background: #f2ae4d;
  color: #ffffff;
}

.yellow:active {
  background: #fa9b15;
}

.add_btn_box {
  /*width: 370px;*/
  padding: 10px;
  position: absolute;
  right: 0px;
}

.add {
  background: #7aafeb;
  color: #ffffff;
  box-shadow: 0 3px 0 #3574ba;
}

.add:active {
  background: #6ca3e2;
}

.publish {
  background: #21b868;
  color: #ffffff;
  box-shadow: 0 3px 0 #188d4f;
}

.publish:active {
  background: #188d4f;
}

.delete {
  background: #f2ae4d;
  color: #ffffff;
  box-shadow: 0px 3px 0px #dc8509;
}

.delete:active {
  background: #e7a342;
}

.table_content {
  width: 100%;
  height: calc(100% - 100px);
  padding: 20px 0px;
}

.table_content > table {
  width: 100%;
  height: 100%;
  border: 1px solid #094b8e;
  background-color: #16518d;
}

.table_content > table tr th {
  background-color: #0e345b;
}

/* .table_content > table tr td {
  background-color: #16518d;
} */

.table_content > table input {
  width: 16px;
  height: 16px;
}

.table_content > table tr:nth-child(2n) {
  background-color: #11406f;
}

.table_content > table tr {
  /*border-bottom: 1px solid #225892;*/
  height: 52px;
}

.table_content > table tr td,
.table_content > table tr th {
  text-align: center;
  color: #ffffff;
}

.table_content > table tr th select {
  background: transparent;
  color: #ffffff;
  border: none;
  outline: none;
}

.table_content > table tr th select option {
  color: #333333;
}

.table_paging {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #105ba8;
  border-radius: 6px;
}

.table_paging > p {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: right;
  margin-bottom: 0;
  color: #c1c2c6;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}

.table_paging > p > button {
  margin: 0 8px;
  width: 10px;
  height: 16px;
  border: none;
  outline: none;
}

.table_btn {
  color: #95bee5;
  background: transparent;
  border: 1px solid #95bee5;
  outline: transparent;
  padding: 5px 20px;
  border-radius: 6px;
}

.model {
  padding: 20px;
  box-sizing: border-box;
}

.model > h1 {
  font-size: 20px;
  color: #00f0ff;
  height: 40px;
  line-height: 40px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #264a7c;
  margin-bottom: 10px;
}

.model > h1 > div {
  float: right;
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
}

.model > h1 > div > label {
  font-size: 16px;
  line-height: 40px;
  color: #ffffff;
  margin-bottom: 0;
}

.model > h1 > div > label > select,
.model > h1 > div > label > input {
  border: 1px solid #ffffff;
  border-radius: 4px;
  background: transparent;
  height: 32px;
  line-height: 32px;
  margin: 0 5px;
  width: 120px;
  color: #ffffff;
  outline: none;
}

.model > h1 > div > label > select > option {
  color: #000000;
}

.model > div {
  width: 100%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
}

.model_input_box {
  width: 100%;
  height: 32px;
  margin: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.twoinput{
  width: 100%;
  height: 40px;
  margin: 10px 20px;
  display: flex;
  align-items: left;
}
.input_span{
  width: 140px;
  padding-right: 20px;
  box-sizing: border-box;
}
.input_span > span{
  width:140px;
  line-height:40px; 
  color:#ffffff;
  text-align: right;
  display: inline-block;
}
.twoinput input{
  width: 180px;
  display: inline-block;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  padding: 0 20px;
  color: #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #ffffff;
  background: transparent;
  outline: none;
  margin-left: 20px;
}
.model_input_box > div:nth-child(1) {
  width: 25%;
  padding-right: 20px;
  box-sizing: border-box;
}

.model_input_box > div:nth-child(1) > span {
  width: 100%;
  display: inline-block;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  text-align: right;
  color: #ffffff;
}

.model_input_box > div:nth-child(2) {
  width: 75%;
  padding-right: 20px;
  box-sizing: border-box;
}

.model_input_box > div:nth-child(2) > input {
  width: 100%;
  display: inline-block;
  height: 40px  !important;
  font-size: 16px;
  line-height: 40px  !important;
  padding: 0 20px;
  color: #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #ffffff;
  background: transparent;
  outline: none;
}
.twoinput select{
  width: 180px;
  display: inline-block;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  padding: 0 10px;
  color: #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #ffffff;
  background: transparent;
  outline: none;
  margin-left: 20px;
}
.twoinput select option{
  color: #000000;
}
.sbt_box {
  width: 100%;
  height: 80px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

#msg {
  height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #00f0ff;
  font-weight: bold;
}

.details {
  width: 100%;
  height: 100%;
}

.details > h1 {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  color: #00f0ff;
}

.details > h1 > button {
  width: 80px;
  display: inline-block;
  margin-left: 20px;
  font-size: 16px;
}

.details > h1 > div {
  float: right;
  width: auto;
  height: 100%;
  color: #ffffff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.details > h1 > div > input {
  margin: 0 10px;
}

.details > h1 > div > button {
  margin: 0 20px;
}

.details > div {
  height: calc(100% - 70px) !important;
}

.monitoringPoint {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.monitoringPoint > h1 {
  font-size: 20px;
  color: #00f0ff;
  height: 20px;
  line-height: 20px;
  margin-bottom: 10px;
}

.monitoringPoint > div {
  width: 100%;
  height: calc(100% - 30px);
  border: 1px solid #094b8e;
  border-radius: 8px;
  overflow: hidden;
}

.monitoringPoint table {
  width: 100%;
  height: 100%;
  border: 1px solid #094b8e;
  border-radius: 5px;
}

.monitoringPoint table thead tr {
  height: 60px;
  border-bottom: 1px solid #094b8e;
}

.monitoringPoint table thead tr th {
  color: #ffffff;
  font-size: 16px;
}

.monitoringPoint table tbody {
  display: block;
  height: 100%;
  overflow-y: scroll;
}

.monitoringPoint table thead tr,
.monitoringPoint table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  text-align: center;
}

.monitoringPoint table tbody tr {
  background: #16518d;
  border-bottom: 1px solid #094b8e;
}

.monitoringPoint table tbody tr:nth-child(2n + 0) {
  background: #11406f;
}

.monitoringPoint table tbody tr td {
  height: 54px;
  color: #ffffff;
}

.monitoringPoint table tbody tr td span {
  width: 46px;
  height: 24px;
  border-radius: 3px;
  line-height: 24px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
}
/*.now > td {*/
/*  color: #00f0ff !important;*/
/*}*/

.monitoringPoint table thead {
  width: calc(100% - 1em);
}
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/5_msg/LED_management.vue